import request from '../../../util/SuperagentUtils';
import { accountEditEndpoints } from '../../../requests/api-endpoints';
import type { AdminAccountReportVO } from '../../../types/admin/AdminAccountReportVO';

/**
 * Account searches for the admin account lookup.
 *
 * The admin account report matches `email` and `username` partially
 * (`LIKE %value%`), so a search for jane@acme.com also returns
 * bigjane@acme.com. Rows come back as the report returns them; callers pick the
 * exact match.
 */

/** Enough rows that the exact match is on the first page behind any partials. */
export const ACCOUNT_MATCH_PAGE_SIZE = 10;

export type AccountSearchField = 'email' | 'username';

export const searchAdminAccounts = async (
  field: AccountSearchField,
  value: string,
): Promise<AdminAccountReportVO[]> => {
  const response = await request
    .get(accountEditEndpoints.adminAccountReport.getAccountReport)
    .query({ [field]: value, page: 0, size: ACCOUNT_MATCH_PAGE_SIZE });
  return (response.body?.content ?? []) as AdminAccountReportVO[];
};

/** One company on the platform, as the admin company filters list it. */
export interface CompanyName {
  id: string;
  companyName: string;
}

export type CompanyAccountType = 'Buyer' | 'Supplier';

/**
 * Every buyer or every supplier company on the platform, for picking out a
 * company an admin names in a question. The same list the admin pages' Buyer and
 * Supplier filters offer, so a company found here filters those pages too.
 */
export const fetchCompanyNames = async (type: CompanyAccountType): Promise<CompanyName[]> => {
  const response = await request.get(accountEditEndpoints.adminAccountReport.getCompanyNames).query({ type });
  const body = response?.body as CompanyName[] | undefined;
  return Array.isArray(body) ? body : [];
};
